const usePageTitle = (pageTitle) => {
	return document.title = `${pageTitle} | Ausome Therapy`;
}

export default usePageTitle;